
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certificaciones/[slug]",
      function () {
        return require("private-next-pages/certificaciones/[slug].js");
      }
    ]);
  